export default "__VITE_ASSET__BuLy4nig__"